/**
 * @flow
 * @relayHash 083533f4ac37de2659b5f728145d506e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CanonicalIssuesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type CanonicalIssuesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  typeFilters?: ?$ReadOnlyArray<?string>,
  sourceUrl?: ?TextFilters,
  canonicalUrl?: ?TextFilters,
|};
export type CanonicalIssuesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CanonicalIssuesTable_project$ref
  |}
|};
export type CanonicalIssuesTable_RefetchQuery = {|
  variables: CanonicalIssuesTable_RefetchQueryVariables,
  response: CanonicalIssuesTable_RefetchQueryResponse,
|};
*/


/*
query CanonicalIssuesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $typeFilters: [String]
  $sourceUrl: TextFilters
  $canonicalUrl: TextFilters
) {
  project(host: $host) {
    ...CanonicalIssuesTable_project_23hoaq
    id
  }
}

fragment CanonicalIssuesTable_project_23hoaq on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesCanonicalIssues(canonicalUrl: $canonicalUrl, sourceUrl: $sourceUrl) {
          type
          severity
          count
        }
        canonicalIssues(offset: $offset, limit: $limit, sourceUrl: $sourceUrl, canonicalUrl: $canonicalUrl, typeFilters: $typeFilters) {
          count
          edges {
            node {
              ...CanonicalIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment CanonicalIssuesRow_issue on CanonicalIssue {
  id
  type
  severity
  canonical_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "canonicalUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "canonicalUrl",
  "variableName": "canonicalUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CanonicalIssuesTable_RefetchQuery",
  "id": null,
  "text": "query CanonicalIssuesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $typeFilters: [String]\n  $sourceUrl: TextFilters\n  $canonicalUrl: TextFilters\n) {\n  project(host: $host) {\n    ...CanonicalIssuesTable_project_23hoaq\n    id\n  }\n}\n\nfragment CanonicalIssuesTable_project_23hoaq on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesCanonicalIssues(canonicalUrl: $canonicalUrl, sourceUrl: $sourceUrl) {\n          type\n          severity\n          count\n        }\n        canonicalIssues(offset: $offset, limit: $limit, sourceUrl: $sourceUrl, canonicalUrl: $canonicalUrl, typeFilters: $typeFilters) {\n          count\n          edges {\n            node {\n              ...CanonicalIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CanonicalIssuesRow_issue on CanonicalIssue {\n  id\n  type\n  severity\n  canonical_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CanonicalIssuesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CanonicalIssuesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "canonicalUrl",
                "variableName": "canonicalUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CanonicalIssuesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesCanonicalIssues",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "canonicalIssues",
                        "storageKey": null,
                        "args": [
                          v2,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v3,
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "CanonicalIssueConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CanonicalIssueEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CanonicalIssue",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v4,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "canonical_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '502bea710a11bfea67ed261087782ee1';
module.exports = node;
